export default __webpack_public_path__ + "static/media/Grips of Bone and Horn.21e853db.jpg";